import { Box, BoxProps, Heading } from '@chakra-ui/react';
import React from 'react';

interface PaperProps {
  heading?: string;
  mb?: number;
  p?: number;
  width?: string | number;
}

type Props = PaperProps & BoxProps;

export const Paper: React.FC<Props> = ({
  heading,
  mb = 2,
  p = 5,
  children,
  shadow = 'md',
  ...rest
}) => {
  return (
    <Box
      p={p}
      shadow={shadow}
      borderWidth="1px"
      borderRadius={5}
      mb={mb}
      bg="white"
      {...rest}
    >
      {heading ? <Heading fontSize="xl">{heading}</Heading> : null}
      {children}
    </Box>
  );
};
